
import { RingLoader } from "react-spinners";

function Header() {
  return (
    <header id="header">
      <nav className="container">
        <a className="brand" href="#main">
          <img src="/logo.png" alt="Tadj Zerroug logo" />
          <div className="brand-text">
            <h2>Tadj Zerroug</h2>
            <p>AI + Full-Stack Engineer</p>
          </div>
        </a>
        <ul className="nav-links">
          <li><a href="#main">Home</a></li>
          <li><a href="#profile">About</a></li>
          <li><a href="#projects">Projects</a></li>
          <li><a href="#journey">Journey</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
        <a className="header-cta" href="mailto:ot_zerroug@esi.dz">Let's talk</a>
        <RingLoader className="donut" color="#ffffff" />
      </nav>
    </header>
  );
}


export default Header ; 